<template>
    <a :href="meetingItem.url" class="meeting-item-wrapper d-flex flex-wrap">
        <span class="meeting-item">{{ meetingItem.startDate }}</span>
        <span class="meeting-item">{{ meetingItem.group }}</span>
        <span class="meeting-item">{{ meetingItem.startTime }}</span>
    </a>
</template>

<script>
export default {
    props: {
        meetingItem: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.meeting-item-wrapper {
    background-color: $brand-white;
    padding: 0 20px;
    margin: 0 -20px;

    &:nth-child(even) {
        background-color: $brand-gray;
    }

    &:hover {
        /* background-color: $brand-blue;*/
        cursor: pointer;
        a {
            text-decoration: underline;
            color: $brand-green-dark-new;
        }
    }
}

.meeting-item {
    flex: 1 1 33.3333%;
    padding: 5px;
    word-break: break-word;
}
</style>
